<template>
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
  >
    <path d="M0.200408 5.26034C0.48226 5.56387 0.956809 5.58145 1.26034 5.29959L5 1.77348L8.73967 5.29959C9.0432 5.58145 9.51775 5.56387 9.7996 5.26034C10.0815 4.95681 10.0639 4.48226 9.76034 4.2004L5.51034 0.200405C5.22258 -0.0668016 4.77743 -0.0668016 4.48967 0.200405L0.239665 4.2004C-0.0638681 4.48226 -0.081444 4.95681 0.200408 5.26034Z" />
  </svg>
</template>
